import { pxToRem } from '@packages/themes/utils';

import { makeStyles } from '@/styles/theme/tss-react';

interface StyleProps {
  isOnDark: boolean;
  align: 'center' | 'start';
}

const useStyles = makeStyles<StyleProps>({ name: 'GoogleReviewsMinimal' })(
  ({ brandColors, spacing, type }, { isOnDark, align }) => {
    const justify = align === 'start' ? 'flex-start' : 'center';
    const textColor = isOnDark
      ? brandColors.tintsOffWhite40
      : brandColors.tintsChargeBlue20;

    return {
      root: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: justify,
        gap: spacing(-1),
      },
      logo: {
        display: 'block',
        flexShrink: 0,
        width: pxToRem(138),
        height: pxToRem(26),
      },
      text: {
        margin: 0,
        color: textColor,
        textAlign: align === 'start' ? 'left' : 'center',
        ...type['18_regular'],
      },
    };
  }
);

export default useStyles;
